/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_No_Client_ActionInputs */

const en_portal_no_client_action = /** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview as a client`)
};

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const ar_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const he_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const ur_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const es_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const fr_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const de_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const pt_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const hi_portal_no_client_action = en_portal_no_client_action;

/** @type {(inputs: Portal_No_Client_ActionInputs) => LocalizedString} */
const bn_portal_no_client_action = en_portal_no_client_action;

/**
* | output |
* | --- |
* | "Preview as a client" |
*
* @param {Portal_No_Client_ActionInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_no_client_action = /** @type {((inputs?: Portal_No_Client_ActionInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_No_Client_ActionInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_no_client_action(inputs)
	if (locale === "he") return he_portal_no_client_action(inputs)
	if (locale === "ur") return ur_portal_no_client_action(inputs)
	if (locale === "es") return es_portal_no_client_action(inputs)
	if (locale === "fr") return fr_portal_no_client_action(inputs)
	if (locale === "de") return de_portal_no_client_action(inputs)
	if (locale === "pt") return pt_portal_no_client_action(inputs)
	if (locale === "hi") return hi_portal_no_client_action(inputs)
	if (locale === "bn") return bn_portal_no_client_action(inputs)
	return /** @type {LocalizedString} */ ("Preview as a client")
});